import ActionNode from './ActionNode'

class ActionNodeGoto extends ActionNode {
  constructor(model) {
    super(model)
    this.text = 'Go to another action'
    this.icon = {
      ...this.icon,
      name: 'branch',
      size: 14
    }
  }
}

export default ActionNodeGoto



// WEBPACK FOOTER //
// ./src/utils/models/node/ActionNodeGoto.js